var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopnotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_2115_52140)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.4404V21.7704",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0199 14C20.3399 14 17.3599 16.98 17.3599 20.66V22.76C17.3599 23.44 17.0799 24.46 16.7299 25.04L15.4599 27.16C14.6799 28.47 15.2199 29.93 16.6599 30.41C21.4399 32 26.6099 32 31.3899 30.41C32.7399 29.96 33.3199 28.38 32.5899 27.16L31.3199 25.04C30.9699 24.46 30.6899 23.43 30.6899 22.76V20.66C30.6799 17 27.6799 14 24.0199 14Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3299 30.8203C27.3299 32.6503 25.8299 34.1503 23.9999 34.1503C23.0899 34.1503 22.2499 33.7703 21.6499 33.1703C21.0499 32.5703 20.6699 31.7303 20.6699 30.8203",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2115_52140",
    x1: 24.5333,
    y1: -1.30741e-7,
    x2: 21.4041,
    y2: 47.8302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F70FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopnotification);
export default __webpack_public_path__ + "static/media/topnotification.e2e43959d3a33ad2e17ebda7129bcfd2.svg";
export { ForwardRef as ReactComponent };